import api from '@/utils/api';

/**
 * Get all company's pricing list
 * @param {string} companyId - Company Id
 * @param {string} query - The query
 * @returns {Promise}
 */
const getCompanyPriceListApi = (companyId, query) =>
  api.get(`company/${companyId}/price${query ? `?${query}` : ''}`);

export default getCompanyPriceListApi;
